import { render, staticRenderFns } from "./AbandonmentRecords.vue?vue&type=template&id=67e02fea&"
import script from "./AbandonmentRecords.vue?vue&type=script&lang=js&"
export * from "./AbandonmentRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports